var _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAnalyticsIcon = function SvgAnalyticsIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 16.7915,
    y: 5.1665,
    width: 3.875,
    height: 20.6667,
    rx: 1.9375,
    fill: "#B5B5C3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.3335,
    y: 11.625,
    width: 3.875,
    height: 14.2083,
    rx: 1.9375,
    fill: "#B5B5C3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23.25,
    y: 14.2085,
    width: 3.875,
    height: 11.625,
    rx: 1.9375,
    fill: "#B5B5C3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.875,
    y: 16.7915,
    width: 3.875,
    height: 9.04166,
    rx: 1.9375,
    fill: "#B5B5C3"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAnalyticsIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzEiIGhlaWdodD0iMzEiIHZpZXdCb3g9IjAgMCAzMSAzMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgb3BhY2l0eT0iMC4zIiB4PSIxNi43OTE1IiB5PSI1LjE2NjUiIHdpZHRoPSIzLjg3NSIgaGVpZ2h0PSIyMC42NjY3IiByeD0iMS45Mzc1IiBmaWxsPSIjQjVCNUMzIi8+CjxyZWN0IHg9IjEwLjMzMzUiIHk9IjExLjYyNSIgd2lkdGg9IjMuODc1IiBoZWlnaHQ9IjE0LjIwODMiIHJ4PSIxLjkzNzUiIGZpbGw9IiNCNUI1QzMiLz4KPHJlY3QgeD0iMjMuMjUiIHk9IjE0LjIwODUiIHdpZHRoPSIzLjg3NSIgaGVpZ2h0PSIxMS42MjUiIHJ4PSIxLjkzNzUiIGZpbGw9IiNCNUI1QzMiLz4KPHJlY3QgeD0iMy44NzUiIHk9IjE2Ljc5MTUiIHdpZHRoPSIzLjg3NSIgaGVpZ2h0PSI5LjA0MTY2IiByeD0iMS45Mzc1IiBmaWxsPSIjQjVCNUMzIi8+Cjwvc3ZnPgo=";